/**
 * Dropdown Navigation Module
 * Obsługuje dropdown menu na desktop i mobile
 */

(function () {
  'use strict';

  // Desktop Dropdown - hover based
  const desktopDropdownItems = document.querySelectorAll('.navbar__desktop .nav-item--has-dropdown:not(.nav-item--has-megamenu)');

  desktopDropdownItems.forEach((item) => {
    const button = item.querySelector('.nav-link');
    const dropdown = item.querySelector('.dropdown-menu');

    if (!button || !dropdown) return;

    // Mouse enter - show dropdown
    item.addEventListener('mouseenter', () => {
      openDesktopDropdown(item, button);
    });

    // Mouse leave - hide dropdown
    item.addEventListener('mouseleave', () => {
      closeDesktopDropdown(item, button);
    });

    // Keyboard support - toggle on Enter/Space
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closeDesktopDropdown(item, button);
        } else {
          openDesktopDropdown(item, button);
        }
      }

      // Close on Escape
      if (e.key === 'Escape') {
        closeDesktopDropdown(item, button);
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!item.contains(e.target)) {
        closeDesktopDropdown(item, button);
      }
    });
  });

  function openDesktopDropdown(item, button) {
    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  }

  function closeDesktopDropdown(item, button) {
    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
  }

  // Mobile Dropdown - click based
  const mobileDropdownItems = document.querySelectorAll('.mobile-nav__item--has-dropdown');

  mobileDropdownItems.forEach((item) => {
    const button = item.querySelector('.mobile-nav__link');
    const dropdown = item.querySelector('.mobile-dropdown');

    if (!button || !dropdown) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMobileDropdown(item, button, dropdown);
    });
  });

  function openMobileDropdown(item, button, dropdown) {
    // Assign stagger indices to cards
    var cards = dropdown.querySelectorAll('.mobile-dropdown__card');
    cards.forEach(function (card, i) {
      card.style.setProperty('--card-i', i);
    });

    // Add is-open (triggers padding transition + card animations)
    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');

    // Next frame: measure full height and set max-height to trigger transition
    // Add 40px to account for vertical padding (20px top + 20px bottom)
    requestAnimationFrame(function () {
      dropdown.style.maxHeight = (dropdown.scrollHeight + 40) + 'px';
    });
  }

  function closeMobileDropdown(item, button, dropdown) {
    // Lock current height before removing is-open
    dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
    // Force reflow so browser registers the starting value
    dropdown.offsetHeight;

    // Remove is-open (triggers padding collapse) + set max-height to 0
    item.classList.remove('is-open');
    dropdown.style.maxHeight = '0';
    button.setAttribute('aria-expanded', 'false');
  }

  function toggleMobileDropdown(item, button, dropdown) {
    var isOpen = item.classList.contains('is-open');

    // Close all other open dropdowns
    mobileDropdownItems.forEach(function (otherItem) {
      if (otherItem !== item && otherItem.classList.contains('is-open')) {
        var otherDropdown = otherItem.querySelector('.mobile-dropdown');
        var otherButton = otherItem.querySelector('.mobile-nav__link');
        if (otherDropdown && otherButton) {
          closeMobileDropdown(otherItem, otherButton, otherDropdown);
        }
      }
    });

    if (isOpen) {
      closeMobileDropdown(item, button, dropdown);
    } else {
      openMobileDropdown(item, button, dropdown);
    }
  }
})();
